import { action, asMap, observable, computed } from 'mobx';
import { Database } from '../firebaseInit.js';

class Course {
  @observable status = 0;

  constructor(id) {
    Database.child('courses').child(id).once('value', (snap) => {
      const course = snap.val();
      (course) ? this.init( Object.assign(this, snap.val(), { status: 200 }) ) : this.set( {status: 404} );
    });
  }

  @action init(data) {
    Object.assign(this, data);
  }

}

class CourseStore {
  @observable courses = asMap({});

  @action loadCourses = (org) => {
    this.dataTransport = true;
    Database.child('organisation').child(org).once('value', (snap) => {
      const { courses } = snap.val();
      Object.keys(courses).forEach(
        courseId => this.courses.set( courseId, new Course(courseId) )
      );
    });
  }

  @action loadId = (courseId) => {
    if(!this.courses.has(courseId)){
      this.courses.set( courseId, new Course(courseId) );
    }
  }

  @computed get all() {
    return this.courses.entries();
  }
}

export default CourseStore;


/** WEBPACK FOOTER **
 ** ./src/js/state/course.js
 **/